export default __webpack_public_path__ + "static/custom-laptop-6ce09db06868c7bcf4dd8b465101e715.webp";